import { makeStyles } from "@fluentui/react-components";
import { ProjectsPage } from "apps/decooda/components/projects/ProjectsPage";
import { NavigationPanel } from "components/navigationPanel/NavigationPanel";
import { designTokens } from "theme/customTheme";

const useStyles = makeStyles({
  container: {
    display: "flex",
    height: "100dvh",
    overflow: "hidden",
    backgroundColor: designTokens.neutral[50],
  },
  navPanel: {
    display: "flex",
    flexWrap: "wrap",
    height: "100dvh",
    backgroundColor: designTokens.neutral[50],
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: 0,
    paddingLeft: designTokens.spacing[5],
    boxSizing: "border-box",
    backgroundColor: designTokens.neutral[50],
    flex: "1",
  },
  contentWrapper: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minWidth: 0,
    flex: "1",
    overflowY: "auto",
    overflowX: "hidden",
  },
});

export const DecoodaProjectsMain = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.navPanel}>
        <NavigationPanel />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.contentWrapper}>
          <ProjectsPage />
        </div>
      </div>
    </div>
  );
};
